import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { TimeWarning, UpdateTimeWarningDto } from 'types';

export const updateTimeWarning = ({
  data,
  analyzerId,
}: {
  data: UpdateTimeWarningDto;
  analyzerId: number;
}): Promise<TimeWarning> => {
  return axios.put(`/api/time-warnings/${analyzerId}`, data);
};

type UseUpdateTimeWarningOptions = {
  analyzerId?: number;
  config?: MutationConfig<typeof updateTimeWarning>;
};

export const useUpdateTimeWarning = ({
  config,
  analyzerId,
}: UseUpdateTimeWarningOptions) => {
  return useMutation({
    onMutate: async (newTimeWarning) => {
      await queryClient.cancelQueries(['analyzer', analyzerId, 'timeWarning']);

      const previousTimeWarning = queryClient.getQueryData<TimeWarning>([
        'analyzer',
        analyzerId,
        'timeWarning',
      ]);

      queryClient.setQueryData(
        ['analyzer', analyzerId, 'timeWarning'],
        newTimeWarning.data
      );

      return { previousTimeWarning };
    },
    onError: (_, __, context: any) => {
      if (context?.previousTimeWarning) {
        queryClient.setQueryData(
          ['analyzer', analyzerId, 'timeWarning'],
          context.previousTimeWarning
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['analyzer', analyzerId]);
    },
    ...config,
    mutationFn: updateTimeWarning,
  });
};
